import type { Schemas } from "@/shared/api/client";

export type TaskPriority = Schemas["TaskPriority"];

/** Every priority, most pressing first: the order of pickers and of the priority sort. */
export const PRIORITIES = [
  "urgent",
  "high",
  "medium",
  "low",
  "none",
] as const satisfies readonly TaskPriority[];

export function isTaskPriority(value: string): value is TaskPriority {
  return (PRIORITIES as readonly string[]).includes(value);
}
